import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { GradePageQuery, GradePageQueryVariables } from './__generated__/GradePageQuery';

const GRADE_PAGE_QUERY = gql`
  query GradePageQuery($id_oferta: Int!, $id_turma: Int!, $dat_inicio: String!, $dat_fim: String!) {
    oferta(id_oferta: $id_oferta) {
      num_oferta
      num_semestre
      num_ano
      dat_inicio
      dat_fim
      assistente {
        dsc_nome
        dsc_email
      }
      curso {
        id_curso
        dsc_nome_curso
        dsc_sigla_curso
        apoio {
          dsc_nome
          dsc_email
          dsc_telefone
        }
        unidade {
          id_unidade
          dsc_nome_unidade
        }
      }
    }
    turma(id_turma: $id_turma) {
      id_turma
      num_turma
      horario {
        hora_inicio
        hora_fim
      }
    }
    horarios {
      id_horario
      hora_inicio
      hora_fim
    }
    feriados(where: { dat_inicio: $dat_inicio, dat_fim: $dat_fim }) {
      id_feriado
      dsc_feriado
      dat_feriado
    }
    alocacoes_professores(
      where: {
        id_oferta: $id_oferta
        id_turma: $id_turma
        dat_inicio: $dat_inicio
        dat_fim: $dat_fim
      }
    ) {
      dat_alocacao
      id_oferta
      id_turma
      id_professor
      id_disciplina
      ind_status
      disciplina {
        id_disciplina
        dsc_sigla
        num_carga_horaria
        num_carga_horaria_to
      }
      professor {
        id_professor
        dsc_nome_professor
      }
      horario {
        hora_inicio
        hora_fim
      }
    }
    projetos_pedagogicos(where: { id_oferta: $id_oferta, id_turma: $id_turma }) {
      ind_semestre
      ind_ordem
      ind_modalidade
      dsc_modalidade
      dat_inicio
      dat_fim
      num_carga_horaria_to
      dsc_sigla_disciplina
      disciplina {
        id_disciplina
        dsc_nome_disciplina
        dsc_sigla
        num_carga_horaria
        num_carga_horaria_to
      }
      professor {
        id_professor
        dsc_nome_professor
      }
    }
  }
`;

const useGradePageQuery = (variables: GradePageQueryVariables) => {
  return useQuery<GradePageQuery, GradePageQueryVariables>(GRADE_PAGE_QUERY, { variables });
};

const useGradePageLazyQuery = () => {
  return useLazyQuery<GradePageQuery, GradePageQueryVariables>(GRADE_PAGE_QUERY);
};

export { useGradePageQuery, useGradePageLazyQuery };
